import React, { useRef, useState, useEffect } from "react";
import {
  computePosition,
  autoUpdate,
  shift,
  flip,
  hide,
} from "@floating-ui/dom";

import { EventModel } from "app/models/EventModel";

import styles from "./styles.module.scss";
import ScheduleBlocksInfo from "./ScheduleBlocksInfo";
import ProgramInfo from "./ProgramInfo";
import TimeSlotReservationInfo from "./TimeSlotReservationInfo";

type PropsDef = {
  event?: EventModel;
  coords?: {
    x: number;
    y: number;
  };
  referenceElement: any;
  onDelete: () => void;
  onEdit: () => void;
  onCopy: () => void;
  timeZone?: string;
};

export default function Event(props: PropsDef) {
  const { event, referenceElement, onDelete, onEdit, onCopy, timeZone } = props;
  const currentElement = useRef(null);
  const [position, setPosition] = useState({ left: 0, top: 0 });
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    if (!referenceElement || !currentElement.current) {
      // @ts-ignore: next-line
      return;
    }

    const cleanup = autoUpdate(referenceElement, currentElement.current, () => {
      computePosition(referenceElement, currentElement.current, {
        middleware: [shift(), flip(), hide()],
      }).then(({ x, y, middlewareData }) => {
        setHidden(middlewareData.hide.referenceHidden);
        setPosition({ left: x, top: y });
      });
    });

    return () => {
      cleanup();
    };
  }, [event?.id, referenceElement]);

  if (!props.event?.id) {
    return null;
  }

  const renderInfoBox = () => {
    if (event.type === "program") {
      return <ProgramInfo event={event} timeZone={timeZone} />;
    } else if (event.type === "time_slot_reservation") {
      return <TimeSlotReservationInfo event={event} />;
    } else {
      return (
        <ScheduleBlocksInfo event={event} onDelete={onDelete} onEdit={onEdit} onCopy={onCopy} />
      );
    }
  };

  return (
    <div
      className={styles.popup}
      ref={currentElement}
      style={{
        left: position.left,
        top: position.top,
        visibility: hidden ? "hidden" : "visible",
        zIndex: 2,
      }}
    >
      {renderInfoBox()}
    </div>
  );
}
